import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import { shop } from '@/api/address'
import { Message } from 'element-ui'
const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password })
        .then(response => {
          shop()
            .then(res => {
              if (res.data.code === 0) {
                localStorage.setItem('shopData', JSON.stringify(res.data.data.list))
              }
            })
            .catch(() => {
            })
          console.log('登录')
          console.log(response.data)
          // if (response.data.code !== 0) {
          //   Message({
          //     message: response.data.msg,
          //     type: 'error'
          //   })
          // }
          if (response.data.code === 0) {
            // const { data } = response
            // localStorage.setItem('token', response.data.data.token)
            localStorage.setItem('username', username)
            localStorage.setItem('password', password)
            localStorage.setItem('userInfo', JSON.stringify(response.data.data))
            commit('SET_TOKEN', response.data.data.token)
            setToken(response.data.data.token)
            resolve()
          } else {
            Message.error(response.data.msg || '登陆失败!')
            reject()
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(response => {
          const { data } = response
          console.log(data)
          localStorage.setItem('userInfo', JSON.stringify(response.data.data))
          if (!data) {
            reject('Verification failed, please Login again.')
          }

          const { roles, name, avatar } = data

          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject('getInfo: roles must be a non-null array!')
          }

          commit('SET_ROLES', roles)
          commit('SET_NAME', name)
          commit('SET_AVATAR', avatar)
          commit('SET_INTRODUCTION', '管理员')
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          // localStorage.removeItem('token')
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resetRouter()

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          dispatch('tagsView/delAllViews', null, { root: true })

          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    // const { roles } = await dispatch('getInfo')
    // console.log(roles);

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', ['admin'], { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  },

  setToken({ commit, dispatch }, UserInfo) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async resolve => {
      const roles = UserInfo.roles
      if (roles.length === 0) {
        roles.push('lowest') // 添加最小权限角色，roles不能为空，为空时会导致一直输出 log ，页面卡死，原因未知
      }
      commit('SET_TOKEN', UserInfo.token)
      commit('SET_NAME', UserInfo.name)
      commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
      commit('SET_ROLES', roles)
      commit('SET_INTRODUCTION', '管理员')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
